<template>
    <div class="argument">
       <h2 class="title">西安店播云信息科技有限公司——店播•嘉维斯业务数据清理协议</h2> 
<div class="headText">欢迎阅读店播•嘉维斯业务数据清理协议(下称“本协议”)。本协议是您与西安店播云信息科技有限公司（以下简称“店播云”）之间有关店播•嘉维斯业务数据清理的法律协议。您一旦进行业务数据清理操作，即表示您同意接受本协议各项条款的约束，并且对本协议已明确知悉并接受。如您不同意本协议中的条款，请不要进行业务数据清理操作。</div>
<ul>
      <div> 1、您保证：</div>
      <li> ①所进行的业务数据清理是您亲自操作。</li>
      <li> ②已充分了解本操作会清理哪些相关数据，会带来什么结果。</li>
      <li>  ③本操作造成的后果由您自行承担，与店播云无关。</li>
      <div> 2、免责声明：</div>
      <li>
        店播云不就您因进行业务数据清理操作而引起的任何间接的、意外的、直接的或其它任何损害承担赔偿责任。即使店播云事先被告知该损害发生的可能性。
      </li>
      <div>3、法律适用和管辖</div>
      <li> 本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因您使用业务数据清理操作导致的争议，您同意接受本公司注册地人民法院的管辖。本网站享有对服务条款的最终解释与修改权 。</li>
</ul>
 <el-button @click="goBack()">我已知晓</el-button>
    </div>
   
</template>
<script>
export default {
      methods:{
            goBack(){
                  this.$router.go(-1)
            }
      }
}
</script>
<style scoped>
  .title{
        text-align: center;
        margin-bottom: 20px;
  }
  .argument{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px 300px;
        box-sizing: border-box;
  }
  .headText{
        font-size: 16px;
        text-indent: 20px;
        line-height: 28px;
  }
  ul{
        line-height: 30px;
  }
  ul>div{
        font-weight: bold;
  }
  .el-button{
        margin-top: 50px;
        text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/page/system/maintain/Agreement.vue